import React from 'react';

interface Props {
  children: React.ReactNode;
  tone?: 'green' | 'gold' | 'dim';
  className?: string;
}

const TONE_CLASS: Record<NonNullable<Props['tone']>, string> = {
  green: 'text-green-700',
  gold: 'text-gold-600',
  dim: 'text-ink-500',
};

export function SectionLabel({ children, tone = 'green', className = '' }: Props) {
  return (
    <span
      className={[
        'inline-block font-display text-eyebrow font-semibold uppercase tracking-[0.14em]',
        TONE_CLASS[tone],
        className,
      ].join(' ')}
    >
      {children}
    </span>
  );
}
